module.exports = __webpack_public_path__ + "static/media/blue-white-gery-s-20.77211943.png";